"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const index_1 = require("../index");
const style = {
    position: 'absolute',
    top: 30,
    left: 0,
    right: 0,
    maxHeight: 250,
    zIndex: 100,
    marginTop: 4,
    overflow: 'auto',
};
const TimePickerOptions = (0, react_1.forwardRef)(function TimePickerOptions({ options, onChange }, ref) {
    return (react_1.default.createElement(index_1.Paper, { ref: ref, sx: style },
        react_1.default.createElement(index_1.List, null, options.map((option) => (react_1.default.createElement(index_1.ListItem, { key: option, button: true, onClick: (event) => {
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();
                onChange(option);
            } },
            react_1.default.createElement(index_1.ListItemText, { primary: react_1.default.createElement(index_1.Typography, { variant: "body1" }, option) })))))));
});
exports.default = TimePickerOptions;
